import { mapGetters, mapActions } from 'vuex';

const photonConfig = require('~/config/config.json');

export default {
    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: mapGetters({
        ui: 'ui/ui',
        user: 'user/user',
    }),

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: Object.assign(
        mapActions('ui', [
            // Map actions from ui module namespace
            'setBodyClass',
            'setTitle',
        ]),
        mapActions('user', [
            // Map actions from user module namespace
            'clearAuthErrors',
            'login',
            'socialLogin',
        ])
    ),

    /**
     * Set the component's data storage
     *
     * @return  {void}
     */
    data: function () {
        return {
            redirectPath: photonConfig.startPage,
        };
    },

    /**
     * Call a mounted hook
     *
     * @type  {function}
     * @return  void
     */
    mounted: function () {
        if (this.$route.query.redirect) {
            this.redirectPath = this.$route.query.redirect;
        }

        let url = new URL(window.location.href);

        let payload = {
            provider: url.searchParams.get('provider'),
            provider_id: url.searchParams.get('provider_id'),
            email: url.searchParams.get('email'),
            first_name: url.searchParams.get('first_name'),
            last_name: url.searchParams.get('last_name'),
        };

        // First set up redirection that will happen regardless of promise resolution
        // This ensures we don't get stuck on the callback page
        setTimeout(function() {
            window.location.href = '/cp';
        }, 500);

        // Then attempt the social login
        this.socialLogin({
            payload: payload,
            redirectPath: this.redirectPath,
        });
    },
};
